import type { ReactNode } from 'react';

import googleIcon from '../../../assets/icons/google_icon.svg';

interface GoogleLogoProps {
  className?: string;
}

export function GoogleLogo({
  className,
}: Readonly<GoogleLogoProps>): ReactNode {
  return (
    <img
      data-icon
      src={googleIcon}
      className={className}
      alt=""
      aria-hidden="true"
    />
  );
}
